import { render, staticRenderFns } from "./resourceComTabs.vue?vue&type=template&id=c69db212&"
import script from "./resourceComTabs.vue?vue&type=script&lang=js&"
export * from "./resourceComTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports